export const uk = {
    archive: 'Архивные',
    creatives: 'Мои креативы',
    upload: 'Загрузить'
};
